import '../../styles/web-components/product-option-dropdown.scss';
class ProductOptionDropdown extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.handleOptionChanged);
        this.windowClick = this.onWindowClick.bind(this);
    }
    connectedCallback() {
        var _a;
        this.id = (_a = this.querySelector('.product-option-dropdown__select')) === null || _a === void 0 ? void 0 : _a.id;
        window.addEventListener("click", this.windowClick);
        this.querySelector('.product-option-dropdown__select-button').addEventListener("click", (e) => {
            var _a;
            const target = e.target;
            (_a = this.querySelector(".product-option-dropdown__select")) === null || _a === void 0 ? void 0 : _a.classList.toggle("active");
            target.setAttribute("aria-expanded", target.getAttribute("aria-expanded") === "true" ? "false" : "true");
        });
    }
    disconnectedCallback() {
        window.removeEventListener("click", this.windowClick);
    }
    handleOptionChanged(e) {
        var _a;
        console.debug("ProductOptionDropdown handleOptionChanged", e.target);
        const target = e.target;
        (_a = this.querySelector(".product-option-dropdown__select")) === null || _a === void 0 ? void 0 : _a.classList.remove("active");
        const event = new CustomEvent("dropdown:valueChanged", { detail: { [target.name]: target.value }, bubbles: true });
        this.dispatchEvent(event);
    }
    onWindowClick(e) {
        var _a, _b;
        const target = e.target;
        if (!(target.id === this.firstElementChild.id || target.closest(`#${this.firstElementChild.id}`))) {
            (_a = this.querySelector(".product-option-dropdown__select")) === null || _a === void 0 ? void 0 : _a.classList.remove("active");
            (_b = this.querySelector(".product-option-dropdown__select-button")) === null || _b === void 0 ? void 0 : _b.setAttribute("aria-expanded", "false");
        }
    }
}
if (!window.customElements.get("product-option-dropdown")) {
    customElements.define("product-option-dropdown", ProductOptionDropdown);
}
